<div class="headline">
  <span class="mat-h1 m0">Wortschatz</span>
  <span class="editing-group">
    @if (authService.getUserRole() === 'ROLE_ADMIN' || authService.getUserRole() === 'ROLE_USER_PAID') {
      <button (click)="toggleSelectMode()" [attr.aria-pressed]="selectMode"
              aria-label="Einträge für Sammelmappen auswählen"
              class="header-buttons" color="primary" mat-flat-button>
        <mat-icon>{{ selectMode ? 'close' : 'create_new_folder' }}</mat-icon>
        <mat-label class="home-new-word-bt-text">{{ selectMode ? 'Auswahl beenden' : 'Sammelmappe' }}</mat-label>
      </button>
    }
    @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
      <button (click)="sendExportVocabularyRequest()"
        aria-label="Button to export complete wordlist"
        class="header-buttons" color="accent" mat-flat-button>
        <mat-icon>share</mat-icon>
        <mat-label class="home-new-word-bt-text"> Vollständiger Export</mat-label>
      </button>
    }
    @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
      <button (click)="openNewCategoryDialog()"
        aria-label="Button to add a new category" class="header-buttons"
        color="primary" mat-flat-button>
        <mat-icon>add</mat-icon>
        <mat-label class="home-new-word-bt-text"> <span class="plain-text-new">Neues</span> Thema</mat-label>
      </button>
    }
    @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
      <button (click)="openNewWordDialog()"
        aria-label="Button to add a new word"
        class="header-buttons"
        color="primary" mat-flat-button>
        <mat-icon>add</mat-icon>
        <mat-label class="home-new-word-bt-text"> <span class="plain-text-new">Neues</span> Wort</mat-label>
      </button>
    }
    @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
      <button (click)="toggleEditingTools(true)"
        aria-label="Button to disable editing"
        class="editing-buttons header-buttons" mat-flat-button>
        <mat-icon>remove_red_eye</mat-icon>
        <mat-label class="home-new-word-bt-text"> Ansicht</mat-label>
      </button>
    }
    @if ((displayEditingTools === false) && (authService.getUserRole() === 'ROLE_ADMIN')) {
      <button (click)="toggleEditingTools(true)"
        aria-label="Button to enable editing"
        class="editing-buttons header-buttons" mat-flat-button>
        <mat-icon>edit</mat-icon>
        <mat-label class="home-new-word-bt-text"> Bearbeiten</mat-label>
      </button>
    }
  </span>
</div>
<hr class="divider">
<div class="main-content-wrapper">
  <app-category-tree [displayEditingTools]="displayEditingTools" [isAdmin]="isAdmin" [service]="categoryService" [reloadRootsTrigger]=reloadRootsTrigger [categoryId]="categoryId"
  [resetCategoryControl]="resetCategoryControl" [title]="'Wortschatzthemen'" (reloadSearch)="handleChildSearch($event)" class="tree-content"></app-category-tree>
  <div class="table-content">
    <div class="mat-elevation" style="background-color: white">
      <app-search-bar [resetTrigger]="resetSearchTrigger" [initialQuery]="initialSearchQuery" (search)="handleSearch($event)" (resetFilter)="handleResetFilter()"></app-search-bar>
      <app-table [displayedColumns]="displayedColumns" [isAuthorized]="isAuthorized" [searchTrigger]="searchTrigger"
      [selectedCategory]="categoryControl" [selectable]="selectMode" [service]="wordService"></app-table>
    </div>
  </div>
</div>
